import * as constants from 'modules/hiring/stateManagement/constants';
import * as actions from 'modules/hiring/stateManagement/actions';
import { IMyOpenRolesResponseData } from 'modules/hiring/models/myOpenRequisition.model';
import { TSelectedOpenRequisitionState } from 'modules/hiring/stateManagement/state';

export function getMyOpenRolesStarted(): actions.IGetMyOpenRolesStarted {
  return {
    type: constants.GET_MY_OPEN_ROLES_STARTED,
  };
}

export function getMyOpenRolesSuccess(
  data: IMyOpenRolesResponseData
): actions.IGetMyOpenRolesSuccess {
  return {
    type: constants.GET_MY_OPEN_ROLES_SUCCESS,
    payload: data,
  };
}

export function getMyOpenRolesFailed(
  errorMessage: string
): actions.IGetMyOpenRolesFailed {
  return {
    type: constants.GET_MY_OPEN_ROLES_FAILED,
    payload: errorMessage,
  };
}

export function setSelectedOpenRequisition(
  requisition: TSelectedOpenRequisitionState
): actions.ISetSelectedOpenRequisition {
  return {
    type: constants.SET_SELECTED_OPEN_REQUISITION,
    payload: requisition,
  };
}

export const actionTriggers = {
  getMyOpenRolesStarted,
  getMyOpenRolesSuccess,
  getMyOpenRolesFailed,
  setSelectedOpenRequisition,
};
